<template>
  <el-drawer
    append-to-body
    ref="priceview"
    :title="title"
    :visible.sync="visibile"
    :direction="direction"
    size="58%"
  >
    <div style="padding: 15px">
      <el-form size="small">
        <el-row :gutter="22">
          <el-form-item>
            <el-col :span="10">
              <el-table
                ref="pricestationname"
                :data="tableData"
                border
                highlight-current-row
                @current-change="handleCurrentChange"
              >
                <el-table-column label="线路" align="center" prop="sectionName" />
              </el-table>
              <div class="tipsBox">
                <img style="width: 20px; height: 20px" src="./static/tips.png" />
                <span style="color: #9f9f9f; margin-left: 5px"
                  >可切换区间修改各个线路之间的价格</span
                >
              </div>
            </el-col>
            <el-col :span="14">
              <el-table :data="children" :span-method="objectSpanMethod" border>
                <el-table-column label="座位号" align="center" prop="seatNumber">
                  <template slot-scope="scope">
                    {{ scope.row.seatNumber + '号座' }}
                  </template>
                </el-table-column>
                <el-table-column label="市场价（元）" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isLock === 1">{{ scope.row.marketPrice }}</div>
                    <div v-else>
                      <el-input
                        style="width: 60%"
                        v-model="scope.row.marketPrice"
                        size="small "
                        placeholder="请输入内容"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="销售价（元）" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isLock === 1">{{ scope.row.sellingPrice }}</div>
                    <div v-else>
                      <el-input
                        @change="changeMInPrice(scope.row)"
                        style="width: 60%"
                        v-model="scope.row.sellingPrice"
                        size="small "
                        placeholder="请输入内容"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="最低价（元）" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.minPrice }}</div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tipsBox">
                <img style="width: 20px; height: 20px" src="./static/danger.png" />
                <span style="color: #fa5a5a; margin-left: 5px"
                  >仅支持修改未售座位价格，且修改后价格不能低于最低价</span
                >
              </div>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item style="display: flex; justify-content: center; margin-top: 50px">
            <el-button type="primary" @click="submitForm">保存</el-button>
            <el-button @click="resetForm">取消</el-button>
          </el-form-item>
        </el-row>
        <el-button
          style="margin: 20px 0 10px 0"
          @click="showLogData"
          :loading="logLoading"
          size="small"
          type="primary"
          >操作日志
          <i class="el-icon-arrow-right" v-if="!showLog"></i>
          <i class="el-icon-arrow-down" v-else></i>
        </el-button>
        <transition name="el-fade-in-linear">
          <operation-log v-show="showLog" :visible="showLog" :flightPlanId="flightPlanId" />
        </transition>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
  import { selectPriceDetail, savePriceMethod } from '@/api/transport/pricescheme'
  import OperationLog from '@/components/logInfo/list'
  export default {
    name: 'priceschemeView',
    components: {
      OperationLog
    },
    data() {
      return {
        visibile: true,
        title: '',
        direction: 'rtl',
        tableData: [],
        stationRuleTypeList: [],
        children: [],
        currentRow: null,
        tableIndex: 0,
        priceInfo: {},
        showLog: false,
        logLoading: false,
        logList: [],
        flightPlanId: ''
      }
    },
    watch: {
      tableData() {
        this.$nextTick(() => {
          // 默认选中
          this.$refs.pricestationname.setCurrentRow(this.tableData[0])
        })
      },
      visibile(newVal) {
        if (!newVal) {
          this.showLog = false
        }
      }
    },
    methods: {
      init(row) {
        this.flightPlanId = row.flightPlanId
        let obj = {}
        if (row.type === 1) {
          obj = row
        } else {
          obj = JSON.parse(row)
        }
        this.visibile = true
        this.title = '修改价格'
        this.stationRuleTypeList = []
        console.log('obj', obj)
        if (obj.type === 1) {
          this.priceInfo = obj
          selectPriceDetail(obj.flightId).then((resp) => {
            this.tableData = resp.data
          })
        } else {
          this.tableData = obj.flightPriceMethodTypes
          this.tableIndex = obj.index
        }
      },
      changeMInPrice(row) {
        if (row.minPrice > row.sellingPrice) {
          this.$message.warning('销售价不能低于最低价！')
          row.sellingPrice = row.minPrice
        }
      },
      // 合并列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 3) {
          if (rowIndex > 0) {
            return {
              rowspan: this.children.length - 1,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      },
      // 选择线路
      handleCurrentChange(val) {
        if (val) {
          this.currentRow = val
          this.children = val.flightPriceMethodType
        }
      },
      // 保存
      submitForm() {
        if (this.priceInfo.type === 1) {
          const para = {
            flightId: this.priceInfo.flightId,
            flightPrices: this.tableData
          }
          savePriceMethod(para).then((resp) => {
            if (resp) {
              console.log(8520, resp)
              this.$message.success('保存成功')
            }
          })
        } else {
          const orderInfo = {
            index: this.tableIndex,
            flightPriceMethodTypes: this.tableData
          }
          this.$emit('revisePriceInfo', orderInfo)
        }
        this.visibile = false
        this.showLog = false
      },
      // 取消
      resetForm() {
        this.visibile = false
        this.showLog = false
      },
      showLogData() {
        this.showLog = !this.showLog
      }
    }
  }
</script>

<style scoped>
  .tipsBox {
    margin: 10px 0 0 15px;
    display: flex;
    align-items: center;
  }
</style>
